var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 raised rounded"},[_c('div',{staticClass:"column-title border-bottom mb-2"},[_vm._v("Items Needed Before Approval")]),_vm._v(" "),_c('ul',_vm._l((this.neededDocs),function(item,idx){return _c('li',{key:idx},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be3bf67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entities/NeededForApproval.vue
// module id = null
// module chunks = 